import { Dispatch } from "react";
import axios from "axios";
import { ReminderAction, ReminderActionTypes } from "./reminderActionTypes";
import { APIMETHOD } from "../../core/constant";

// Define async action for fetching all reminders
export const fetchReminders = async (
  dispatch: Dispatch<ReminderAction>,
  token: any,
  clientId: number
) => {
  dispatch({ type: ReminderActionTypes.FETCH_REMINDERS_REQUEST });
  try {
    const response = await axios.get(APIMETHOD.reminder.GET_ALL, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        client: clientId
      }
    });
    const data = response.data;
    dispatch({
      type: ReminderActionTypes.FETCH_REMINDERS_SUCCESS,
      payload: data.results,
    });
    return data
  } catch (error: any) {
    dispatch({
      type: ReminderActionTypes.FETCH_REMINDERS_FAILURE,
      payload: error.message,
    });
  }
};

// Define async action for fetching all reminders
export const fetchRemindersByClientId = async (
  dispatch: Dispatch<ReminderAction>,
  token: any
) => {
  dispatch({ type: ReminderActionTypes.FETCH_REMINDERS_REQUEST });
  try {
    const response = await axios.get(APIMETHOD.reminder.GET_ALL, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
      // params: {
      //   client: clientId
      // }
    });
    const data = response.data;
    dispatch({
      type: ReminderActionTypes.FETCH_REMINDERS_SUCCESS,
      payload: data.results,
    });
  } catch (error: any) {
    dispatch({
      type: ReminderActionTypes.FETCH_REMINDERS_FAILURE,
      payload: error.message,
    });
  }
};

// Define async action for posting a reminder
export const postReminder = async (
  dispatch: Dispatch<ReminderAction>,
  reminderData: any,
  token: any
) => {
  dispatch({ type: ReminderActionTypes.POST_REMINDER_REQUEST });
  try {
    const response = await axios.post(
      APIMETHOD.reminder.ADD_REMINDER,
      reminderData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const data = response.data;
    dispatch({
      type: ReminderActionTypes.POST_REMINDER_SUCCESS,
      payload: data,
    });
  } catch (error: any) {
    dispatch({
      type: ReminderActionTypes.POST_REMINDER_FAILURE,
      payload: error.message,
    });
  }
};

export const patchReminder: any = async (
  dispatch: Dispatch<ReminderAction>,
  reminderData: any,
  token: any
) => {
  dispatch({ type: ReminderActionTypes.PATCH_REMINDER_REQUEST });
  try {
    const response = await axios.patch(
      APIMETHOD.reminder.ADD_REMINDER + reminderData?.id + '/',
      reminderData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const data = response.data;
    dispatch({
      type: ReminderActionTypes.PATCH_REMINDER_SUCCESS,
      payload: data,
    });
    return data;
  } catch (error: any) {
    dispatch({
      type: ReminderActionTypes.PATCH_REMINDER_FAILURE,
      payload: error.message,
    });
    return error;
  }
};

export const deleteReminder: any = async (
  dispatch: Dispatch<ReminderAction>,
  reminderData: any,
  token: any
) => {
  dispatch({ type: ReminderActionTypes.DELETE_REMINDER_REQUEST });
  try {
    const response = await axios.delete(
      APIMETHOD.reminder.ADD_REMINDER + reminderData?.id + '/',
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const data = response.data;
    dispatch({
      type: ReminderActionTypes.DELETE_REMINDER_SUCCESS,
      payload: reminderData,
    });
    return data;
  } catch (error: any) {
    dispatch({
      type: ReminderActionTypes.DELETE_REMINDER_FAILURE,
      payload: error.message,
    });
    return error;
  }
};
